export var OBVDirectionalBias;
(function (OBVDirectionalBias) {
    OBVDirectionalBias["bullish"] = "bullish";
    OBVDirectionalBias["bearish"] = "bearish";
    OBVDirectionalBias["neutral"] = "neutral";
})(OBVDirectionalBias || (OBVDirectionalBias = {}));
export var OBVSignalRelationship;
(function (OBVSignalRelationship) {
    OBVSignalRelationship["aboveSignal"] = "aboveSignal";
    OBVSignalRelationship["belowSignal"] = "belowSignal";
    OBVSignalRelationship["nearSignal"] = "nearSignal";
})(OBVSignalRelationship || (OBVSignalRelationship = {}));
export var OBVStructureTrend;
(function (OBVStructureTrend) {
    OBVStructureTrend["higherHighsHigherLows"] = "higherHighsHigherLows";
    OBVStructureTrend["lowerHighsLowerLows"] = "lowerHighsLowerLows";
    OBVStructureTrend["range"] = "range";
    OBVStructureTrend["mixed"] = "mixed";
})(OBVStructureTrend || (OBVStructureTrend = {}));
export var OBVBreakoutState;
(function (OBVBreakoutState) {
    OBVBreakoutState["aboveLookbackHigh"] = "aboveLookbackHigh";
    OBVBreakoutState["belowLookbackLow"] = "belowLookbackLow";
    OBVBreakoutState["insideRange"] = "insideRange";
})(OBVBreakoutState || (OBVBreakoutState = {}));
export var OBVDivergenceType;
(function (OBVDivergenceType) {
    OBVDivergenceType["bullish"] = "bullish";
    OBVDivergenceType["bearish"] = "bearish";
    OBVDivergenceType["hiddenBullish"] = "hiddenBullish";
    OBVDivergenceType["hiddenBearish"] = "hiddenBearish";
})(OBVDivergenceType || (OBVDivergenceType = {}));
export var OBVDivergenceStrength;
(function (OBVDivergenceStrength) {
    OBVDivergenceStrength["strong"] = "strong";
    OBVDivergenceStrength["moderate"] = "moderate";
    OBVDivergenceStrength["weak"] = "weak";
})(OBVDivergenceStrength || (OBVDivergenceStrength = {}));
export var OBVEventType;
(function (OBVEventType) {
    OBVEventType["crossedAboveSignal"] = "crossedAboveSignal";
    OBVEventType["crossedBelowSignal"] = "crossedBelowSignal";
    OBVEventType["bullishDivergenceDetected"] = "bullishDivergenceDetected";
    OBVEventType["bearishDivergenceDetected"] = "bearishDivergenceDetected";
    OBVEventType["hiddenBullishDivergence"] = "hiddenBullishDivergence";
    OBVEventType["hiddenBearishDivergence"] = "hiddenBearishDivergence";
    OBVEventType["divergenceConfirmed"] = "divergenceConfirmed";
    OBVEventType["divergenceExpired"] = "divergenceExpired";
    OBVEventType["bullishBreakoutConfirmed"] = "bullishBreakoutConfirmed";
    OBVEventType["bearishBreakdownConfirmed"] = "bearishBreakdownConfirmed";
    OBVEventType["enteredAccumulation"] = "enteredAccumulation";
    OBVEventType["enteredDistribution"] = "enteredDistribution";
    OBVEventType["newLocalHigh"] = "newLocalHigh";
    OBVEventType["newLocalLow"] = "newLocalLow";
})(OBVEventType || (OBVEventType = {}));
//# sourceMappingURL=OBVAnalyzerTypes.js.map